import React from 'react';
import { Card, Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import styled from '@emotion/styled';

const Article = styled.article`
  color: white;
`;

const Header = styled.header`
  margin-bottom: 2rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Paragraph = styled.p`
  color: #fff;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const Heading = styled.h2`
  color: #fff;
  font-size: 1.25rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const List = styled.ul`
  color: #fff;
  font-size: 1rem;
  margin-left: 2rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const ListItem = styled.li`
  margin-bottom: 0.5rem;
`;

const Link = styled.a`
  color: #1976d2;
  text-decoration: none;
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 2rem 0;
`;

const DataDeletionPage = () => {
  return (
    <VuiBox py={3}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={8}>
          <Card>
            <VuiBox p={3}>
              <Article>
                <Header>
                  <VuiTypography variant="h3" color="white" fontWeight="bold" mb={2}>
                    Data Deletion Instructions
                  </VuiTypography>
                </Header>

                <Divider />

                <Section>
                  <Heading>
                    How to Request Data Deletion
                  </Heading>
                  <Paragraph>
                    Send an email to <Link href="mailto:admin-saas@dailymentor.com.au">admin-saas@dailymentor.com.au</Link> with the subject line "Data Deletion Request" and include:
                  </Paragraph>
                  <List>
                    <ListItem>Your email address associated with your account</ListItem>
                    <ListItem>Your Facebook User ID (if known)</ListItem>
                  </List>
                  <Paragraph>
                    We will process your request within 30 days and send you a confirmation email.
                  </Paragraph>
                </Section>

                <Divider />

                <Section>
                  <Heading>
                    What Data Will Be Deleted
                  </Heading>
                  <List>
                    <ListItem>Your Facebook account information (Account ID)</ListItem>
                    <ListItem>Ad account connections and authorization data</ListItem>
                    <ListItem>Cached ads insights and performance data retrieved from your Facebook ad accounts</ListItem>
                  </List>
                </Section>
              </Article>
            </VuiBox>
          </Card>
        </Grid>
      </Grid>
    </VuiBox>
  );
};

export default DataDeletionPage;
